import { Box } from "@material-ui/core";
import { TransferenciaHistoricoModel } from "model/api/gestao/transferencia/transferencia-historico-model";
import { useState } from "react"
import { AccordionSaurus } from "views/components/accordions/accordion-saurus/accordion-saurus"
import { HistoricoTransferenciaData } from "views/pages/private/inicial/components/historico-transferencia/historico-transferencia-data";

interface AccordionHistoricoTransferenciaProps {
    historico: TransferenciaHistoricoModel[];
}

export const AccordionHistoricoTransferencia = ({
    historico,
}: AccordionHistoricoTransferenciaProps) => {
    const [openned, setOpenned] = useState<boolean>(false);

    return (
        <AccordionSaurus
            labelPrimary="Histórico da Transferência"
            expanded={openned}
            onChange={() => setOpenned(prev => !prev)}
        >
            <Box width='100%'>
                <HistoricoTransferenciaData
                    list={historico}
                    onCardClick={() => { }}
                />
            </Box>
        </AccordionSaurus>
    )
}